import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <>
    <path d="M23.9999 4L4 18.9999V43.9998H17.4999V33.4999C17.4999 29.8988 20.3989 26.9998 24 26.9998C27.6011 26.9998 30.5001 29.8988 30.5001 33.4999V43.9998H44V18.9999L23.9999 4Z" />
  </>,
  'home'
);
